/**
 * "/admin" — the presenter photo library (F-134), with the admin's view of
 * it: the same grid every editor opens from a thumbnail panel
 * (features/presenter-photos/PresenterLibraryDialog), plus the two
 * corrections only an admin makes — the description a run chooses by, and
 * whether a photo is offered at all.
 *
 * The tagging model is the `portrait-tagging` default in the cards above:
 * an upload is described by the server, on that model, before it answers,
 * so there is no per-sitting picker here — "Apply only me" on that card and
 * "Re-tag" is how an admin tries another model on a photo.
 */
import { useEffect } from "react";

import { loadPresenterPhotos } from "../presenter-photos/load.js";
import { PresenterLibrary } from "../presenter-photos/PresenterLibraryDialog.js";
import { useLibraryUploads } from "../presenter-photos/uploads.js";

export function PresenterPhotosSection() {
  const uploads = useLibraryUploads();

  useEffect(() => {
    void loadPresenterPhotos();
  }, []);

  return (
    <section className="admin-section">
      <div className="admin-section-head">
        <h2>Presenter photos</h2>
        <span className="admin-card-hint">
          Photos of the presenter that every thumbnail run chooses a face from — shared with
          everyone, and anyone who edits boards can add to them from a board's Thumbnails panel or
          here. Each photo is described by AI as it lands (its expression, pose and gaze); a run
          then picks the photo whose expression fits each hook and keeps that expression exactly.
          Photos are never removed: fix a description by hand if the AI misread it, or untick
          "Offer to runs" to keep a photo out.
        </span>
      </div>
      <PresenterLibrary uploads={uploads} editable />
    </section>
  );
}
